import type { PersistenceOptions } from "pinia-plugin-persistedstate";


const piniaPersistConfig = (key: string, paths?: string[]) => {
  const persist: PersistenceOptions = {
    key,
    storage: localStorage,
    pick: paths || undefined, // 只有在 paths 存在时才设置
  };
  return persist;
};

export default piniaPersistConfig;
